import { defineComponent } from 'vue';
export default defineComponent({
    name: 'tax-hint',
    props: {
        tax: {
            type: Number,
            required: true,
        },
    },
    computed: {
        taxText() {
            if (this.tax > 0) {
                return `Preis inkl. ${this.tax}% MwSt.`;
            }
            else if (this.tax === 0) {
                return 'Artikel wird nach §25a UStG. differenzbesteuert';
            }
            return '';
        },
    },
});
